import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/styles.scss'
import '@/styles/newStyles.scss'
import 'v-calendar/dist/style.css';
// import 'bootstrap'

import i18n from '@/translations/index'

import '@/assets/fontawesome/css/fontawesome.css'
import '@/assets/fontawesome/css/brands.css'
import '@/assets/fontawesome/css/solid.css'
import 'quill/dist/quill.core.css'; // import the Quill core styles
import 'quill/dist/quill.snow.css'; // import the Snow theme styles
import 'quill/dist/quill.bubble.css'; // import the Bubble theme styles
import Select2 from 'vue3-select2-component';

import VCalendar from 'v-calendar';
import { createGtm } from '@gtm-support/vue-gtm';

const gtmEnabled = process.env.VUE_APP_GTM_ENABLED === 'true';

//G-5P99LCJC2H
const gm = createGtm({
    id: 'GTM-WH44856K',
    defer: false,
    compatibility: false,
    enabled: gtmEnabled, 
    debug: !gtmEnabled, 
    vueRouter: router,
    trackOnNextTick: false,
})

const app = createApp(App)
    .use(store)
    .use(i18n)
    .use(router)
    .use(gm)
    .use(VCalendar, {})
    .component('Select2', Select2)

app.mount('#app')
